"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var styled_components_1 = require("styled-components");

var react_socks_1 = require("react-socks");

var mobx_react_1 = require("mobx-react");

var withConfiguration_1 = require("../../../shared/withConfiguration");

var Translate_1 = require("../Translate/Translate");

var shared_1 = require("../../../shared");

var Asset_1 = require("../Asset/Asset");

var assets_1 = require("../../../assets/assets");

var Accessibility_1 = require("../Accessibility/Accessibility");

var defaultComponentConfiguration_1 = require("../../../configurations/defaultComponentConfiguration");

var Application_meta_1 = require("./Application.meta");

var mobx_1 = require("mobx");

var FontFaces_1 = require("./styledComponents/FontFaces");

var Application =
/** @class */
function (_super) {
  __extends(Application, _super);

  function Application(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Application_meta_1.APPLICATION_CATEGORY_KEY;
    _this.componentKey = Application_meta_1.APPLICATION_COMPONENT_KEY;
    react_socks_1.setDefaultBreakpoints(_this.props.breakpointDefinitions);
    return _this;
  }

  Object.defineProperty(Application.prototype, "configuration", {
    get: function get() {
      var _a = this.props,
          _b = _a.configuration,
          configuration = _b === void 0 ? {} : _b,
          appKey = _a.appKey;
      var mergedConfiguration = ksys_app_template_1.utils.object.deepMergeObjects(defaultComponentConfiguration_1.DEFAULT_COMPONENT_CONFIGURATION, configuration, {
        appKey: appKey
      });
      return mergedConfiguration;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Application.prototype, "translationContextValue", {
    get: function get() {
      var _a = this.props,
          _b = _a.translate,
          translate = _b === void 0 ? function (key, placeholders) {
        return key;
      } : _b,
          _c = _a.culture,
          culture = _c === void 0 ? 'en-GB' : _c;
      return {
        translate: translate,
        culture: culture
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Application.prototype, "assetContextValue", {
    get: function get() {
      var _a = this.props,
          assetRegisters = _a.assetRegisters,
          assetCacheOptions = _a.assetCacheOptions;
      var assets = this.props.assets;

      if (assets && typeof assets === 'object') {
        assets = ksys_app_template_1.utils.object.deepMergeObjects(assets_1.assets, assets);
      } else {
        assets = assets_1.assets;
      }

      return Asset_1.AssetContextValue(assets, assetRegisters, assetCacheOptions);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Application.prototype, "accessibilityContextValue", {
    get: function get() {
      var _a = this.props.accessibilityText,
          accessibilityText = _a === void 0 ? function (key, defaultValue) {
        return key;
      } : _a;
      return {
        accessibilityText: accessibilityText
      };
    },
    enumerable: true,
    configurable: true
  });

  Application.prototype.render = function () {
    var _a = this.props,
        _b = _a.theme,
        theme = _b === void 0 ? {} : _b,
        children = _a.children,
        className = _a.className;
    var baseUrl = this.assetContextValue.baseUrl();
    return react_1.default.createElement(withConfiguration_1.ConfigurationContext.Provider, {
      value: this.configuration
    }, react_1.default.createElement(Asset_1.AssetContext.Provider, {
      value: this.assetContextValue
    }, react_1.default.createElement(Translate_1.TranslationContext.Provider, {
      value: this.translationContextValue
    }, react_1.default.createElement(Accessibility_1.AccessibilityContext.Provider, {
      value: this.accessibilityContextValue
    }, react_1.default.createElement(styled_components_1.ThemeProvider, {
      theme: theme
    }, react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(FontFaces_1.FontFaces, {
      fontFaces: theme.fontFaces,
      baseUrl: baseUrl
    }), react_1.default.createElement(react_socks_1.BreakpointProvider, null, react_1.default.createElement("section", {
      className: className
    }, children))))))));
  };

  Application.defaultProps = {
    theme: {},
    culture: 'en-GB',
    breakpointDefinitions: [{
      xsmall: 0
    }, {
      small: 576
    }, {
      medium: 768
    }, {
      large: 992
    }, {
      xlarge: 1200
    }]
  };

  __decorate([mobx_1.computed], Application.prototype, "configuration", null);

  Application = __decorate([mobx_react_1.observer], Application);
  return Application;
}(shared_1.ComponentBase);

exports.Application = Application;
exports.default = shared_1.InjectedStyledComponent(Application, Application_meta_1.APPLICATION_CATEGORY_KEY, Application_meta_1.APPLICATION_COMPONENT_KEY);